import React, { useCallback, useEffect, useRef } from 'react';

import { Navigate } from 'react-router-dom';

import useUser from 'hooks/useUser';
import AppRoutes from 'routes/routes';

const PrivateRoute = ({ element, isAuthenticated }) => {
  const { getMe } = useUser();
  const isCallingApi = useRef(false);

  const getUser = useCallback(() => {
    if (!isCallingApi.current) {
      isCallingApi.current = true;
      getMe();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return isAuthenticated ? element : <Navigate to={AppRoutes.login} replace />;
};

export default React.memo(PrivateRoute);
